<template>
  <div class="SubSectionModules">
    <h3 class="title">
      {{ $t('title') }}
    </h3>
    <Row>
      <Column v-for="(module, index) in modules" :key="index" :sm="6" :xs="12">
        <ColumnModule :module="module" />
      </Column>
    </Row>
  </div>
</template>

<script>
import ColumnModule from './ColumnModule'

export default {
  components: {
    ColumnModule,
  },
  data() {
    return {
      modules: [
        {
          themeColor: '#4dbeed',
          logo: require('@/assets/quipment/modules/trina-logo.png'),
          modulePic: require('@/assets/quipment/modules/trinasolar-module.jpg'),
          capacity: '425 W',
          intro: 'Monokristaliniai saulės moduliai',
          descriptionParagraphs: [
            'Trina Solar yra Tier 1 (Bloomberg) sąrašo modulių gamintojas, turintis daugiau nei 26 metų gamybos patirtį ir 9.5 GW modulių gamybos pajėgumus.',
            'Tiekėjo moduliams suteikiama 25 metų 84.8% veiklos efektyvumo garantija.',
          ],
          techDetails: {
            size: '1762 x 1134 x 30 mm',
            power: '425 W',
            guarantee: '15 metų',
          },
          pros: [
            {
              icon: require('@/assets/quipment/modules/icons/efficiency.png'),
              label: 'Mažesnis, nei įprasta, dydis – didelis efektyvumas',
            },
            {
              icon: require('@/assets/quipment/modules/icons/gears.png'),
              label: 'Universalus sprendimas tiek gyvenamųjų namų, tiek komercinių pastatų stogams',
            },
            {
              icon: require('@/assets/quipment/modules/icons/handshake.png'),
              label: 'Ilgaamžiškumą užtikrinantis atsparumas',
            },
            // {
            //   icon: require('@/assets/quipment/modules/icons/current-conductor.png'),
            //   label: '10 srovėlaidžių (mažesni vidiniai nuostoliai)',
            // },
            // {
            //   icon: require('@/assets/quipment/modules/icons/anti-pid.png'),
            //   label: 'Atsparus PID efektui',
            // },
            // {
            //   icon: require('@/assets/quipment/modules/icons/less-sun.svg'),
            //   label: 'Efektyvesnis esant silpnam apšvietimui',
            // },
            // {
            //   icon: require('@/assets/quipment/modules/icons/shield.svg'),
            //   label: 'Sertifikuota atlaikyti ypač sudėtingomis aplinkos sąlygomis',
            // },
            // {
            //   icon: require('@/assets/quipment/modules/icons/winner-podium.svg'),
            //   label: 'Priklauso Bloomberg Tier 1 sąrašui',
            // },
            // {
            //   icon: require('@/assets/quipment/modules/icons/great-quality.png'),
            //   label: 'Puikios kokybės valdymo sistema',
            // },
          ],
        },
        {
          themeColor: '#734bdc',
          logo: require('@/assets/quipment/modules/recom-logo.png'),
          modulePic: require('@/assets/quipment/modules/recom-module.jpg'),
          capacity: '420 W',
          intro: 'Monokristaliniai saulės moduliai',
          descriptionParagraphs: [
            'Recom Technologies yra Tier 1 (Bloomberg) sąrašo modulių gamintojas, lyderiaujantis Europos rinkoje.',
            'Tiekėjo moduliams suteikiama 30 metų 85.95% veiklos efektyvumo garantija.',
          ],
          techDetails: {
            size: '1722 x 1134 x 30 mm',
            power: '420 W',
            guarantee: '25 metai',
          },
          pros: [
            {
              icon: require('@/assets/quipment/modules/icons/temperature.png'),
              label: 'Puikus atsparumas temperatūros pokyčiams',
            },
            {
              icon: require('@/assets/quipment/modules/icons/modules.png'),
              label: 'Atsparūs šviesos sukeltai degradacijai',
            },
            {
              icon: require('@/assets/quipment/modules/icons/efficiency.png'),
              label: 'Didesnis gamybos-per-modulio plotą koeficientas',
            },
            // {
            //   icon: require('@/assets/quipment/modules/icons/shield.svg'),
            //   label: 'Sertifikuota atlaikyti ypač sudėtingomis sąlygomis',
            // },
            // {
            //   icon: require('@/assets/quipment/modules/icons/size-effectiveness.png'),
            //   label: 'Puikus mažas apšvitos efektyvumas',
            // },
            // {
            //   icon: require('@/assets/quipment/modules/icons/anti-pid.png'),
            //   label: 'Atsparus PID efektui',
            // },
          ],
        },
      ],
    }
  },
  computed: {
  },
}
</script>

<style lang="scss">
.SubSectionModules {
  .title {
    color: $main;
    font-size: 2rem;
    font-weight: $bold;
    // padding-bottom: 3rem;
    text-align: center;
  }

}
</style>
<i18n>
{
  "lt": {
    "title": "Saulės moduliai"
  }
}
</i18n>
